import React from 'react';
import { useNavigate } from 'react-router-dom';
import LoginPageNew from './LoginPageNew';

export const LoginPageWrapper = ({ isAuthenticated }) => {
	const navigate = useNavigate();
	function navigateToPortal() {
		navigate('/portal');
	}
	return <LoginPageNew navigateToPortal={navigateToPortal} isAuthenticated={isAuthenticated} />;
};
